import { normalizeAdvertiserItem } from '@/lib/adapters/advertiser.adapter'
import type { AffiliateLinkServerType, AffiliateLinkType } from '@/lib/types/affiliate-link.types'

export const normalizeAffiliateLink = (link: AffiliateLinkServerType): AffiliateLinkType => {
  return {
    id: link.id,
    userId: link.user_id,
    country: link.country,
    provider: link.provider,
    advertiser: normalizeAdvertiserItem(link.advertiser),
    url: link.url,
    originalUrl: link.original_url,
  }
}
